import dayjs from "dayjs";

import { apiFormat } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { DataStates } from "app/pages/digital-marketing/backlinks/shared/BacklinksTypes";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

const backlinksErrorTexts = {
    [DataStates.NO_DATA]: {
        noDataTitle: "digitalsuite.backlinks.common.no_data.title",
        noDataSubtitle: "digitalsuite.backlinks.common.no_data.subtitle",
    },
    [DataStates.ERROR]: {
        noDataTitle: "global.nodata.notavilable",
        noDataSubtitle: "workspaces.marketing.nodata.subtitle",
    },
    [DataStates.PARTIAL_DATA]: {
        noDataTitle: "digitalsuite.backlinks.common.error.large_domain.title",
        noDataSubtitle: "digitalsuite.backlinks.common.error.large_domain.subtitle",
    },
};

const PARTIAL_DATA_RESPONSE_STATUS = 207;

// The api has a restriction of 10,000 records in paginated data
// We set this data here instead of pulling this info from the config as the config represented on the app level
// And requires a considerable amount of refactoring to be able to use it
export const MAX_LIMIT_RECORDS = 10000;
export const DEFAULT_PAGE_SIZE = 100;
// The default index range for backlinks to show the progress period (LAST MONTH/WEEK - TODAY)
export const DEFAULT_ITEM_INDEX_RANGE_FOR_IN_PROGRESS_PERIOD = 2;
// We use UTC for all date calculations as the api is using UTC
export const TODAY = dayjs().utc().endOf("day");
export const START_DATE_13_M = TODAY.subtract(12, "month").startOf("month");
export const API_DATE_REQUEST_FORMAT = apiFormat;

const REF_DOMAIN_API_EP = `/api/backlinks/refdomains`;
const REF_DOMAIN_EXCEL_API_EP = "/api/backlinks/refdomains/Excel";
const SUMMARY_API_EP = `/api/backlinks/summary`;
const BACKLINKS_TABLE_API_URL_EP = "api/backlinks/backlinks";
const BACKLINKS_TABLE_EXCEL_API_URL_EP = "/api/backlinks/backlinks/Excel";
const BACKLINKS_TIMESERIES_API_URL_EP = "/api/backlinks/timeseries";
const BACKLINKS_TIMESERIES_EXCEL_API_URL_EP = "/api/backlinks/timeseries/excel";
const BACKLINKS_TIMESERIES_NEW_LOST_API_URL_EP = "/api/backlinks/timeseries/newlost";
const BACKLINKS_TIMESERIES_NEW_LOST_EXCEL_API_URL_EP = "/api/backlinks/timeseries/newlost/excel";

export const BacklinksApiEP = {
    refDomains: REF_DOMAIN_API_EP,
    domainsExcel: REF_DOMAIN_EXCEL_API_EP,
    summary: SUMMARY_API_EP,
    backlinks: BACKLINKS_TABLE_API_URL_EP,
    backlinksExcel: BACKLINKS_TABLE_EXCEL_API_URL_EP,
    timeseries: BACKLINKS_TIMESERIES_API_URL_EP,
    timeseriesExcel: BACKLINKS_TIMESERIES_EXCEL_API_URL_EP,
    newLostTimeseries: BACKLINKS_TIMESERIES_NEW_LOST_API_URL_EP,
    newLostTimeseriesExcel: BACKLINKS_TIMESERIES_NEW_LOST_EXCEL_API_URL_EP,
};

export const GRANULARITY_INDEX = {
    DAILY: 0,
    WEEKLY: 1,
    MONTHLY: 2,
} as const;

export const TIME_RANGES = {
    DAYS_28: 28,
    MONTH_3: 3,
    MONTH_6: 6,
    MONTH_13: 13,
} as const;

export const TIME_RANGES_INDEX = Object.keys(TIME_RANGES).reduce(
    (acc, key, index) => {
        acc[key as keyof typeof TIME_RANGES] = index;

        return acc;
    },
    {} as Record<keyof typeof TIME_RANGES, number>,
);

export const NEW_VS_LOST_GRAPH_TABS = {
    REFERRING_DOMAINS: 0,
    BACKLINKS: 1,
};

export const chartTimeGranularityOptions = [
    {
        title: "D",
        value: GranularityNames.DAILY,
        disabled: false,
    },
    {
        title: "W",
        value: GranularityNames.WEEKLY,
        disabled: false,
    },
    {
        title: "M",
        value: GranularityNames.MONTHLY,
        disabled: false,
    },
];

export const chartTimeRangeOptions = [
    // Take the lasts 28 days
    {
        title: "28D",
        value: TIME_RANGES.DAYS_28,
    },
    // Take the lasts 3 months
    {
        title: "3M",
        value: TIME_RANGES.MONTH_3,
    },
    // Take the lasts 6 months
    {
        title: "6M",
        value: TIME_RANGES.MONTH_6,
    },
    // Take the lasts 12 months
    {
        title: "13M",
        value: TIME_RANGES.MONTH_13,
    },
];

export const BacklinksChartColors = {
    BACKLINKS: colorsPalettes.orange[400],
    REFDOMAINS: colorsPalettes.midnight[300],
    NEW_LOST_LOST: colorsPalettes.orange["400"],
    NEW_LOST_NEW: colorsPalettes.midnight["300"],
};
